import { TFunction } from "i18next";
import * as Yup from "yup";

export const validationDomain = (t: TFunction) =>
  Yup.object().shape({
    domain: Yup.string()
      .required(t("validation.required"))
      .min(1, t("validation.short"))
      .max(255, t("validation.long"))
      .matches(/\..+$/, t("validation.containDots"))
      .matches(/^[a-zA-Z0-9.-]+$/, t("validation.onlyEnglish")),
  });

export const validationSubdomain = (t: TFunction) =>
  Yup.object().shape({
    domain: Yup.string()
      .required(t("validation.required"))
      .min(1, t("validation.short"))
      .max(255, t("validation.long"))
      .matches(/^[a-zA-Z0-9.-]+$/, t("validation.onlyEnglish"))
      .test(
        "at-least-two-dots",
        t("validation.contain2Dots"),
        (value) => (value?.match(/\./g) || []).length >= 2
      ),
  });
